export function jsonToCSV(items) {
  if (!items || !items.length) return "";

  const header = Object.keys(items[0]);
  const headerRow = header.join(",");

  const rows = items.map((obj) =>
    header
      .map((field) => {
        const value = obj[field] ?? "";
        const stringValue = String(value);
        if (
          stringValue.includes(",") ||
          stringValue.includes('"') ||
          stringValue.includes("\n")
        ) {
          return `"${stringValue.replace(/"/g, '""')}"`;
        }
        return stringValue;
      })
      .join(",")
  );

  return [headerRow, ...rows].join("\n");
}

export function csvIntoJson(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      const text = e.target.result;
      const lines = text.split(/\r?\n/).filter(Boolean);

      if (lines.length === 0) return resolve([]);

      const expectedHeaders = ["titulo", "img", "hostname", "lat", "long"];
      const headers = lines[0].split(",").map((h) => h.trim());
      // Validar os headers
      if (
        headers.length !== expectedHeaders.length ||
        !expectedHeaders.every((h) => headers.includes(h))
      ) {
        return reject(new Error(`Header do CSV inválido.`));
      }

      const result = lines.slice(1).map((line) => {
        const values = line.split(",");
        const obj = {};
        headers.forEach((header, i) => {
          obj[header] = values[i] ? values[i].trim() : "";
        });
        return obj;
      });
      resolve(result);
    };
    reader.onerror = function (e) {
      reject(e);
    };
    reader.readAsText(file);
  });
}
